import { cn } from "@bentolabs/kit/utils";

type Props = {
  className?: string;
};
export const Header = ({ className }: Props) => {
  return (
    <div
      className={cn(
        "text-nobel/50 hidden w-full grid-cols-[3fr_1fr_1fr_0.5fr] items-center rounded-[10px] px-3 font-normal md:grid",
        className
      )}
    >
      <div>Pool</div>
      <div>Rewards</div>
      <div>Action</div>
      <div>&nbsp;</div>
    </div>
  );
};
